<template>
  <div class="insure-page">
    <div class="page-top">
      <h2 class="page-title">新增保险合作客户</h2>
      <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增</el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      stripe
      empty-text="暂无数据"
      :header-cell-style="headerCellStyle"
    >
      <el-table-column prop="index" label="序号" width="70" align="center" />
      <el-table-column prop="name" label="保险公司名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="shortName" label="简称" min-width="100" show-overflow-tooltip />
      <el-table-column prop="contact" label="联系人" min-width="100" show-overflow-tooltip />
      <el-table-column prop="contactTel" label="联系方式" min-width="120" show-overflow-tooltip />
      <el-table-column prop="email" label="操作联系邮箱" min-width="160" show-overflow-tooltip />
      <el-table-column prop="passport" label="登录账号" min-width="120" show-overflow-tooltip />
      <el-table-column label="重置密码" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            :disabled="!scope.row.userId"
            @click="resetPassword(scope.row)"
          >重置</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="新增保险公司名单"
      :visible.sync="dialogVisible"
      width="520px"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="保险公司名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入完整保险公司名称" />
        </el-form-item>
        <el-form-item label="简称" prop="shortName">
          <el-input v-model="form.shortName" placeholder="请输入简称" />
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="form.contact" placeholder="请输入联系人" />
        </el-form-item>
        <el-form-item label="联系手机号" prop="contactTel">
          <el-input v-model="form.contactTel" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="操作邮箱" prop="email">
          <el-input v-model="form.email" placeholder="用于接收账号密码" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { wListRegulators, wAddRegulators, wResetRegulatorPasswd } from "@/views/axios/api.js";
import { normalizeRegulatorList, isBizJson } from "@/util/insureApiCompat.js";

/**
 * 新增保险合作客户
 */
export default {
  name: "InsureAddCustomer",
  data() {
    return {
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data") || "{}").data,
      loading: false,
      submitting: false,
      dialogVisible: false,
      tableData: [],
      form: {
        name: "",
        shortName: "",
        contact: "",
        contactTel: "",
        email: "",
      },
      rules: {
        name: [{ required: true, message: "请输入保险公司名称", trigger: "blur" }],
        shortName: [{ required: true, message: "请输入简称", trigger: "blur" }],
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        contactTel: [{ required: true, message: "请输入联系手机号", trigger: "blur" }],
      },
      headerCellStyle: {
        background: "#f5f7fb",
        color: "#303133",
        fontWeight: "600",
      },
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    /**
     * 加载客户列表（兼容 HTML / JSON）
     */
    loadList() {
      this.loading = true;
      wListRegulators({ token: this.token })
        .then((res) => {
          var normalized = normalizeRegulatorList(res.data);
          if (normalized.code === -1) {
            this.$message.error(normalized.msg || "加载失败");
            this.tableData = [];
            return;
          }
          if (normalized.code !== 0) {
            this.$message.error(normalized.msg || "加载失败，错误号：" + normalized.code);
            this.tableData = [];
            return;
          }
          this.tableData = normalized.list;
        })
        .catch(() => {
          this.$message.error("加载客户列表失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * 打开新增弹窗
     */
    openAdd() {
      this.resetForm();
      this.dialogVisible = true;
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.form = {
        name: "",
        shortName: "",
        contact: "",
        contactTel: "",
        email: "",
      };
      if (this.$refs.formRef) this.$refs.formRef.clearValidate();
    },

    /**
     * 提交新增（现网扁平参数）
     */
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        wAddRegulators({
          token: this.token,
          name: this.form.name,
          shortName: this.form.shortName,
          contact: this.form.contact,
          contactTel: this.form.contactTel,
          email: this.form.email,
        })
          .then((res) => {
            if (!isBizJson(res.data) || Number(res.data.code) !== 0) return;
            this.$message.success("新增成功，默认密码 abc12345");
            this.dialogVisible = false;
            this.loadList();
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },

    /**
     * 重置密码
     * @param {Object} row 表格行
     */
    resetPassword(row) {
      if (!row.userId) {
        this.$message.warning("未获取到用户ID，无法重置");
        return;
      }
      this.$confirm("确认将该账号密码重置为 abc12345？", "提示", { type: "warning" })
        .then(() => wResetRegulatorPasswd({ token: this.token, id: row.userId }))
        .then((res) => {
          if (!isBizJson(res.data) || Number(res.data.code) !== 0) return;
          this.$message.success("密码已重置为 abc12345");
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.insure-page {
  text-align: left;
  padding: 8px 8px 24px;
}
.page-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/add.vue